import React from "react";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import Hero from "../../components/MedicalImaging/Hero/Hero";
import { products_1 } from '../../Data/products';
import { products_2 } from '../../Data/products';
import { products_3 } from '../../Data/products';
import { products_4 } from '../../Data/products';
import { products_5 } from '../../Data/products';
//--------------------------------------------
import Serv from '../../components/Serv' ;
import SubServ from '../../components/SubServ' ;
import Frame from '../../components/Frame';
import UpButton from '../../components/UpButton';
//============================================
import styles from "./Products.module.scss";
import { Helmet } from "react-helmet";
//== 
import  { useContext ,useEffect } from 'react';
import { LanguageContext } from '../../context/LanguageContext';
//==
const Products = ({scroll , lang}) => {
  //---
  const { toggleLanguage } = useContext(LanguageContext);
  useEffect(() => {
    toggleLanguage(lang)
  },);
  //--- 
  return (
    <div>
      <Helmet>
        <title>Millensys - Products</title>
      </Helmet>
      <UpButton scroll={scroll} />
      <div>
        <Header />
        <Hero Healthcare={false}/>
        <Serv Healthcare={false}/>
        <Frame/>
        <h4 className={styles._headding}>A Smart Products Portfolio</h4>
        <SubServ products={products_1} title={'Healthcare Informatics Platform'} overview={'Complete set of products for a total management of hospitals , medical centers , radiology imaging centers, laboratories and healthcare organizations.'}/>
        <SubServ products={products_2} title={'Diagnostic Imaging Platform'} overview={'Complete Imaging Platform for ultimate diagnosis in enterprise diagnostic centers.'}/>
        <SubServ products={products_3} title={'Financial Management Platform'} overview={'Complete set of financial management solutions for a total management of healthcare and business organizations.'}/>
        <SubServ products={products_4} title={'Clinical Speciality Solutions'} overview={'Software solutions for a clinical management and other modules to complete the picture'}/>
        <SubServ products={products_5} title={'Add-ons'} overview={'Software solutions for a clinical management and other modules to complete the picture'}/>
        <Footer />
      </div>
    </div>
  );
};

export default Products;
